import { useId } from 'react';

import { fieldStyle } from '../dashboards/primitives';
import { Field } from '../dashboards/primitives/Field';

import { requiredProps } from './steps/step-layout';

interface Props {
  label: string;
  hint?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  type?: 'text' | 'tel' | 'email';
  placeholder?: string;
  maxWidth?: number;
  /** Text shown before the input, e.g. a currency sign. */
  prefix?: string;
  inputMode?: 'decimal' | 'numeric';
}

/** A labelled single-line input for the inline forms. */
export default function TextField(props: Props) {
  const { label, hint, value, onChange, error, required, type, placeholder, maxWidth } = props;
  const errorId = useId();
  const input = (
    <input
      aria-label={label}
      {...requiredProps(error)}
      aria-required={required ? true : undefined}
      aria-describedby={error ? errorId : undefined}
      type={type}
      inputMode={props.inputMode}
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      style={fieldStyle(error ? 'error' : undefined, maxWidth ? { maxWidth } : undefined)}
    />
  );
  return (
    <Field
      label={label}
      required={required}
      error={error}
      errorId={errorId}
      linkControl={false}
      hint={hint && <span style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>{hint}</span>}
    >
      {props.prefix ? (
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 14, color: 'var(--nb-subtle)' }}>{props.prefix}</span>
          {input}
        </span>
      ) : (
        input
      )}
    </Field>
  );
}
